var _path, _path2;
var _excluded = ["svgRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgPicture4 = function SvgPicture4(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96 96",
    id: "Icons_Medical",
    overflow: "hidden",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 16C30.3 16 16 30.3 16 48 16 65.7 30.3 80 48 80 65.7 80 80 65.7 80 48 80 30.3 65.7 16 48 16ZM48 86C27 86 10 69 10 48 10 27 27 10 48 10 69 10 86 27 86 48 86 69 69 86 48 86Z",
    fill: "#4472C4",
    fillOpacity: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68 40 56 40 56 28C56 25.8 54.2 24 52 24L44 24C41.8 24 40 25.8 40 28L40 40 28 40C25.8 40 24 41.8 24 44L24 52C24 54.2 25.8 56 28 56L40 56 40 68C40 70.2 41.8 72 44 72L52 72C54.2 72 56 70.2 56 68L56 56 68 56C70.2 56 72 54.2 72 52L72 44C72 41.8 70.2 40 68 40Z",
    fill: "#4472C4",
    fillOpacity: 1
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPicture4, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Picture4.674cf78c.svg";
export { ForwardRef as ReactComponent };